import Timeline from '../components/Timeline';
import LightboxGallery from '../components/LightboxGallery';
import Slider from 'react-slick';
import '../css/weddingPage.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import foto1 from '../images/WhatsApp Image 2025-09-01 at 12.55.15.jpeg';
import foto2 from '../images/WhatsApp Image 2025-09-01 at 12.55.16 (1).jpeg';
import foto3 from '../images/WhatsApp Image 2025-09-01 at 12.55.16.jpeg';
import foto4 from '../images/WhatsApp Image 2025-09-01 at 12.55.17 (1).jpeg';
import foto5 from '../images/WhatsApp Image 2025-09-01 at 12.55.17 (2).jpeg';
import foto6 from '../images/WhatsApp Image 2025-09-01 at 12.55.17 (3).jpeg';
import foto7 from '../images/WhatsApp Image 2025-09-01 at 12.55.17.jpeg';
import foto8 from '../images/WhatsApp Image 2025-09-01 at 12.55.18 (1).jpeg';
import foto9 from '../images/WhatsApp Image 2025-09-01 at 12.55.18 (2).jpeg';
import foto10 from '../images/WhatsApp Image 2025-09-01 at 12.55.18 (3).jpeg';
import foto11 from '../images/WhatsApp Image 2025-09-01 at 12.55.18.jpeg';
import foto12 from '../images/WhatsApp Image 2025-09-01 at 12.55.19 (1).jpeg';
import foto13 from '../images/WhatsApp Image 2025-09-01 at 12.55.19 (2).jpeg';
import foto14 from '../images/WhatsApp Image 2025-09-01 at 12.55.19.jpeg';
import foto15 from '../images/WhatsApp Image 2025-09-01 at 12.55.20.jpeg';

export default function DiaDosNamorados() {
  const fotos = [
    foto1, foto2, foto3, foto4, foto5, foto6, foto7, foto8,
    foto9, foto10, foto11, foto12, foto13, foto14, foto15
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  return (
    <>
      <section className="story-section">
        <Timeline
          events={[
            { date: '', title: 'Tudo começou em 2014, quando, por acaso, nos encontramos em uma disciplina da faculdade. Ao final da aula, descobrimos que pegávamos o mesmo ônibus para casa — e foi nesse trajeto que surgiram as primeiras conversas, risadas e afinidades.' },
            { date: '', title: 'O tempo passou e, sem perceber, estávamos construindo uma história juntos. De lá para cá, foram muitos momentos, sonhos realizados, aprendizados e conquistas lado a lado.' },
            { date: '', title: 'Hoje, celebramos não apenas o destino que nos uniu, mas também o amor que escolhemos cultivar a cada dia. E é com imensa alegria que convidamos vocês para fazer parte deste capítulo tão especial: o nosso casamento.' },
          ]}
        />
      </section>

      <section className="gallery-section">
        <h2>Nossas Memórias 💞</h2>
        <Slider {...settings}>
          {fotos.map((src, i) => (
            <div key={i} className="slider-img-w">
              <img src={src} alt={`Foto ${i + 1}`} className="slider-img" />
            </div>
          ))}
        </Slider>
        <LightboxGallery images={fotos} className="" />
      </section>
    </>
  );
}
